import { render, staticRenderFns } from "./selectRadio.vue?vue&type=template&id=a80ead2e&scoped=true"
import script from "./selectRadio.vue?vue&type=script&lang=js"
export * from "./selectRadio.vue?vue&type=script&lang=js"
import style0 from "./selectRadio.vue?vue&type=style&index=0&id=a80ead2e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80ead2e",
  null
  
)

export default component.exports